import classNames from 'classnames';
import { Tag } from '@servicetitan/design-system';
import styles from './SearchResultBadge.module.css';

interface SearchResultBadgeProps {
  count: number;
}

const SearchResultBadge = ({ count }: SearchResultBadgeProps) => {
  const showBadge = count > 0;

  if (!showBadge) {
    return null;
  }

  return (
    <Tag
      className={classNames('cursor-pointer', styles.badge)}
      compact
      badge
      size={2}
    >{`+${count}`}</Tag>
  );
};

export default SearchResultBadge;
